import { debounce } from '@src/utils';
const BP_SIDEBAR = 768;

class StickySidebar {
  constructor(el) {
    this.el = el;
    this.body = document.querySelector('body');
    this.sidebarTopEl = el.querySelector('.sticky-sidebar__top');
    this.sidebarBottomEl = document.querySelector('.sticky-sidebar__bottom');
    this.siteFooterEl = document.querySelector('.footer');
    this.siteNavEl = document.querySelector('.nav');
    this.wpAdminBar = document.querySelector('#wpadminbar');

    // Bind.
    this.checkSidebar = debounce(this.checkSidebarFn.bind(this), 100);

    // Run on load
    this.checkSidebarFn();

    // And on window resize
    window.addEventListener('resize', this.checkSidebar);
  }

  checkSidebarFn() {
    const buffer = 10; // extra padding
    const siteFooterHeight = this.siteFooterEl ? this.siteFooterEl.offsetHeight : 0;
    const siteNavHeight = this.siteNavEl ? this.siteNavEl.offsetHeight : 0;
    const wpAdminBarHeight = this.wpAdminBar ? this.wpAdminBar.offsetHeight : 0;

    // Available space: site nav and footer aren't on the screen at the same time, so just take the larger
    const containerHeight =
      window.innerHeight - (buffer + wpAdminBarHeight + Math.max(siteNavHeight, siteFooterHeight));

    // Contents
    const contentsTopHeight = this.sidebarTopEl ? this.sidebarTopEl.offsetHeight : 0;
    const contentsBottomHeight = this.sidebarBottomEl ? this.sidebarBottomEl.offsetHeight : 0;
    const contentsHeight = contentsTopHeight + contentsBottomHeight;

    const sidebarActive = window.matchMedia(`(min-width: ${BP_SIDEBAR}px)`).matches;

    if (
      sidebarActive &&
      contentsHeight < containerHeight &&
      !this.body.classList.contains('single-event')
    ) {
      this.body.classList.remove('sidebar-overflow');
    } else {
      this.body.classList.add('sidebar-overflow');
    }
  }

  deinit() {
    window.removeEventListener('resize', this.checkSidebar);
  }
}

export default StickySidebar;
